var _path, _path2, _circle, _circle2, _circle3, _circle4, _g, _circle5, _circle6, _circle7, _circle8, _g2, _circle9, _circle0, _circle1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 92,
  height: 92,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#04BBFF",
  fillRule: "evenodd",
  d: "m8.5 31 .494 1.286c.304.79.929 1.416 1.72 1.72L12 34.5l-1.286.494a3 3 0 0 0-1.72 1.72L8.499 38l-.493-1.286a3 3 0 0 0-1.72-1.72L5 34.5l1.286-.494a3 3 0 0 0 1.72-1.72z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBC02D",
  fillRule: "evenodd",
  d: "m83 36 .424 1.102c.26.678.796 1.214 1.475 1.475L86 39l-1.101.424a2.57 2.57 0 0 0-1.475 1.474L83 42l-.424-1.102a2.57 2.57 0 0 0-1.475-1.474L80 39l1.101-.423a2.57 2.57 0 0 0 1.475-1.475zM18.494 48l.494 1.284c.304.79.928 1.414 1.718 1.717l1.283.494-1.283.494a2.99 2.99 0 0 0-1.718 1.717l-.494 1.284-.493-1.284a2.99 2.99 0 0 0-1.718-1.717L15 51.495l1.283-.494a2.99 2.99 0 0 0 1.718-1.717z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 49.212,
  r: 22.788,
  fill: "#F2A178"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 22.432,
  fill: "url(#Money_svg__a)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 22.432,
  fill: "url(#Money_svg__b)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 22.432,
  stroke: "#F4C357",
  strokeWidth: 0.712
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Money_svg__c)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45.788,
  cy: 46.364,
  r: 22.788,
  fill: "url(#Money_svg__d)"
}))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 18.515,
  fill: "#FDEF65"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 18.515,
  fill: "url(#Money_svg__e)"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 18.515,
  fill: "url(#Money_svg__f)",
  fillOpacity: 0.5
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.212,
  cy: 46.364,
  r: 18.159,
  stroke: "#EC8332",
  strokeOpacity: 0.2,
  strokeWidth: 0.712
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#Money_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#Money_svg__h)",
  d: "M48.759 56.846q-1.927 0-3.54-.68a8 8 0 0 1-2.749-2.011q-1.132-1.303-1.756-3.201-.623-1.898-.623-4.334 0-2.407.623-4.306.624-1.926 1.756-3.229a7.7 7.7 0 0 1 2.748-1.983q1.615-.708 3.54-.708 1.417 0 2.437.312 1.048.282 1.813.764.765.454 1.303 1.077.515.566.935 1.131a.14.14 0 0 1-.03.199l-2.844 2.06a.145.145 0 0 1-.209-.044q-.596-1-1.364-1.505-.795-.567-2.04-.566-1.36 0-2.436.878-1.049.878-1.473 2.407h6.373c.078 0 .142.064.142.143v2.264a.14.14 0 0 1-.142.143h-6.6v1.926h6.6c.078 0 .142.064.142.142v2.265a.14.14 0 0 1-.142.142H44.85q.397 1.615 1.444 2.465 1.049.822 2.465.822 2.337 0 3.687-2.27a.145.145 0 0 1 .21-.043l2.85 2.091a.14.14 0 0 1 .034.192q-.402.596-.946 1.19-.566.624-1.416 1.134a7.5 7.5 0 0 1-1.926.821q-1.077.312-2.493.312"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Money_svg__i)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.606,
  cy: 33.545,
  r: 4.273,
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Money_svg__j)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 28.697,
  cy: 27.849,
  r: 1.424,
  fill: "#FBC02D"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#Money_svg__k)",
  style: {
    mixBlendMode: "overlay"
  }
}, _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 66.439,
  cy: 69.864,
  r: 0.712,
  fill: "#FBC02D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Money_svg__c",
  width: 91.151,
  height: 91.151,
  x: 0.212,
  y: 0.788,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 11.394
})), /*#__PURE__*/React.createElement("filter", {
  id: "Money_svg__g",
  width: 15.473,
  height: 26.149,
  x: 40.091,
  y: 36.394,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5.697
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.848
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.921569 0 0 0 0 0.521569 0 0 0 0 0.235294 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "shape",
  result: "effect1_innerShadow"
})), /*#__PURE__*/React.createElement("filter", {
  id: "Money_svg__i",
  width: 19.939,
  height: 19.939,
  x: 48.636,
  y: 23.576,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 2.848
})), /*#__PURE__*/React.createElement("filter", {
  id: "Money_svg__j",
  width: 5.697,
  height: 5.697,
  x: 25.849,
  y: 25,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 0.712
})), /*#__PURE__*/React.createElement("filter", {
  id: "Money_svg__k",
  width: 4.273,
  height: 4.273,
  x: 64.303,
  y: 67.727,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  result: "effect1_foregroundBlur",
  stdDeviation: 0.712
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Money_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(90 10.75 36.462)scale(34.8939)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE89"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6DD54"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Money_svg__e",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(33.179 -54.21 102.421)scale(22.1217)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFCB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.322,
  stopColor: "#FFFA6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#F9D858"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F4AC41"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "Money_svg__f",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(79.046 -4.471 47.425)scale(22.4854)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Money_svg__a",
  x1: 47.212,
  x2: 47.212,
  y1: 23.576,
  y2: 69.151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5DC50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Money_svg__d",
  x1: 45.788,
  x2: 45.788,
  y1: 23.576,
  y2: 69.152,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFE91"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F5DC50"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Money_svg__h",
  x1: 53.723,
  x2: 43.1,
  y1: 37.916,
  y2: 53.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E47437"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1A53D"
})))));
export { SvgMoney as ReactComponent };
export default __webpack_public_path__ + "Money.683c9710.svg";